/* ============================================================
   WB CARD RENDER — hydratation d'un <template> à jetons.
   Aucune connaissance de Shopify ni d'Algolia : ce module prend
   un template et un dictionnaire, il rend un élément DOM.

   Directives :
     %%CLE%%              jeton, dans le texte comme dans les attributs
     data-wb-if="CLE"     supprime l'élément si data[CLE] est falsy
     data-wb-html="CLE"   injecte data[CLE] comme HTML brut
     data-wb-repeat="CLE" clone l'élément une fois par entrée de data[CLE],
                          chaque entrée servant de dictionnaire au clone
   ============================================================ */
(function () {
  const TOKEN = /%%([A-Z0-9_]+)%%/g;

  function resolve(str, data) {
    return str.replace(TOKEN, function (_, key) {
      const v = data[key];
      return v == null || v === false ? '' : String(v);
    });
  }

  // Les classes issues d'un jeton vide laisseraient un espace parasite.
  function tidyClass(el) {
    if (!el.hasAttribute('class')) return;
    const cleaned = el.getAttribute('class').replace(/\s+/g, ' ').trim();
    if (cleaned) el.setAttribute('class', cleaned);
    else el.removeAttribute('class');
  }

  function substituteAttributes(el, data) {
    const attrs = Array.prototype.slice.call(el.attributes);
    for (let i = 0; i < attrs.length; i++) {
      if (attrs[i].value.indexOf('%%') === -1) continue;
      el.setAttribute(attrs[i].name, resolve(attrs[i].value, data));
    }
    tidyClass(el);
  }

  function substituteTextNodes(root, data) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].nodeValue.indexOf('%%') === -1) continue;
      nodes[i].nodeValue = resolve(nodes[i].nodeValue, data);
    }
  }

  function expandRepeats(root, data) {
    const gabarits = root.querySelectorAll('[data-wb-repeat]');
    for (let i = 0; i < gabarits.length; i++) {
      const gabarit = gabarits[i];
      if (!gabarit.parentNode) continue;
      const key = gabarit.getAttribute('data-wb-repeat');
      const items = Array.isArray(data[key]) ? data[key] : [];
      for (let j = 0; j < items.length; j++) {
        const clone = gabarit.cloneNode(true);
        clone.removeAttribute('data-wb-repeat');
        hydrate(clone, items[j]);
        gabarit.parentNode.insertBefore(clone, gabarit);
      }
      gabarit.parentNode.removeChild(gabarit);
    }
  }

  function pruneConditionals(root, data) {
    const nodes = root.querySelectorAll('[data-wb-if]');
    for (let i = 0; i < nodes.length; i++) {
      const el = nodes[i];
      // Un parent supprimé emporte ses descendants : ne pas les retraiter.
      if (!root.contains(el)) continue;
      const v = data[el.getAttribute('data-wb-if')];
      const vide = !v;
      if (vide) el.parentNode.removeChild(el);
      else el.removeAttribute('data-wb-if');
    }
  }

  function applyHtml(root, data) {
    const nodes = root.querySelectorAll('[data-wb-html]');
    for (let i = 0; i < nodes.length; i++) {
      const el = nodes[i];
      if (!root.contains(el)) continue;
      const key = el.getAttribute('data-wb-html');
      el.removeAttribute('data-wb-html');
      el.innerHTML = data[key] == null ? '' : String(data[key]);
    }
  }

  function substituteAll(root, data) {
    substituteAttributes(root, data);
    const els = root.querySelectorAll('*');
    for (let i = 0; i < els.length; i++) substituteAttributes(els[i], data);
    substituteTextNodes(root, data);
  }

  // Les gabarits portent data-wb-href plutôt que href pour que les crawlers ne
  // suivent pas les jetons %%URL%% comme des URLs relatives ; l'attribut est
  // promu en href une fois hydraté.
  function promoteHrefs(root, els) {
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      if (!el.hasAttribute || !el.hasAttribute('data-wb-href')) continue;
      el.setAttribute('href', el.getAttribute('data-wb-href'));
      el.removeAttribute('data-wb-href');
    }
  }

  // L'ordre compte : on développe les répétitions avant d'élaguer, puis on substitue
  // les jetons avant d'injecter le HTML brut. Le HTML injecté par data-wb-html ne doit
  // jamais être traité comme un gabarit : s'il était substitué après coup, une séquence
  // %%CLE%% présente dans ce HTML brut serait réécrite à tort. Les attributs du
  // conteneur portant data-wb-html (ex. data-id="%%ID%%") sont hydratés par
  // substituteAll avant que son innerHTML ne soit remplacé, donc rien n'est perdu.
  function hydrate(root, data) {
    const d = data || {};
    expandRepeats(root, d);
    pruneConditionals(root, d);
    substituteAll(root, d);
    promoteHrefs(root, [root].concat(
      Array.prototype.slice.call(root.querySelectorAll('[data-wb-href]'))
    ));
    applyHtml(root, d);
  }

  function render(templateId, data) {
    const tpl = document.getElementById(templateId);
    if (!tpl || !tpl.content) return null;
    const root = tpl.content.cloneNode(true).firstElementChild;
    if (!root) return null;
    hydrate(root, data);
    return root;
  }

  window.WBCardRender = Object.freeze({ render: render, hydrate: hydrate });
})();
